export default "__VITE_ASSET__v3F1Si8G__"